<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="成果名称" prop="title">
          <a-input v-model="form.title" />
        </a-form-model-item>
        
        <a-form-model-item label="级别" prop="levelType">
          <div class="flex">
            <a-select v-model="form.levelType">
              <a-select-option :value="item.text" v-for="item in jblist" :key="item.text">{{
                item.title
              }}</a-select-option>
             <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.levelType == '其他'">
              <a-input v-model="form.otherType" class="ipt-other" />
            </template>
          </div>
        </a-form-model-item>
         <!-- prop="amount" -->
        <a-form-model-item label="数量">
          <a-input-number
            v-model="form.amount"
            min="1"
            precision="0"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        title: "",
        acquireYear: "",
        amount: "",
        levelType: "",
        otherType: "",
      },
      rules: {
         acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear!='') {
                callback(); // 验证通过
              } else {
                callback(new Error('请选择成果获得年份'));
              }
            },
            required: true,
            message: "请选择成果获得年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入成果名称",
            trigger: "blur",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // amount: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
        levelType: [
          {
            required: true,
            message: "请输入级别",
            trigger: "change",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
    };
  },
  components: { BaseEditor },
  mounted() {
  },
  methods: {
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      const year = moment(value).format('YYYY');
      this.form.acquireYear =year+"";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("acquireYear");
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.getcgjb();
      if (type == "add") {
        this.form = {};
        // this.form.applyId = record.id;
        this.form.acquireYear=new Date().getFullYear()+"";
        this.title = "新增成果";
      } else {
        this.title = "编辑成果";
        this.form = {
          title: record?.title,
          amount: record.amount,
          levelType: record.levelType,
          // courseType: record.courseType,
          // applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          // content: record.content,
          otherType:record.otherType,
        };
      }
    },
    handleCancel() {
      this.visible = false;
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      	if (res.code == 200) {
      		this.jblist=res.result;
      	}
      });
    },
    submit() {
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" 
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let params = this.form;
            if(this.$parent.oldInfos?.id){
                  params.applyType = this.applyType;
                  params.applyId=this.$parent.oldInfos?.id;
                  if (
                    typeof this.form.acquireYear == "object" &&
                    this.form.acquireYear != ""
                  ) {
                    this.form.acquireYear =
                      new Date(this.form.acquireYear).getFullYear() + "";
                  }
                  postAction("/lxBase/lxApplyAchievement/add", params).then((res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("添加成功");
                    this.$emit("addGain",{});
                  } else {
                    this.$message.error(res.message);
                  }
                });

            }else{
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain",{record:params,type:'add'});
            }
          
           
            
          } else {
            let params = this.form;
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            if(this.$parent.oldInfos?.id){
              params.applyType = this.applyType;
              params.applyId=this.$parent.oldInfos?.id;
               putAction("/lxBase/lxApplyAchievement/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("addGain",{});
                } else {
                  this.$message.error(res.message);
                }
              });
            }else{
               this.visible = false;
              this.$message.success("编辑成功");
              this.$emit("addGain",{record:params,type:'edit'});
            }
            
           
           
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
  